export const FEATURE_GATE_METADATA: Record<string, string> = {
  entity: "Entities",
  feature: "Features & Events",
  cm_copilot: "Case Management Copilot",
  tktl_agents: "Agent Builder",
};

export const getFeatureGateTitle = (key: string): string =>
  FEATURE_GATE_METADATA[key] ?? key;
